import { render, staticRenderFns } from "./OnlyContent.vue?vue&type=template&id=0c7cc472&"
import script from "./OnlyContent.vue?vue&type=script&lang=js&"
export * from "./OnlyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports